export default "__VITE_ASSET__DrQKxliA__"